import _ from 'underscore';
import $ from 'jquery';
import Backbone from 'backbone';
import FavoriteCatalogItems from './FavoriteCatalogItems';
import app from '../app';

export default Backbone.Model.extend({

    initialize: function () {},

    urlRoot: function () {
        return `${app.config.contextPath}/user_profiles`;
    },

    url: function () {
        return `${this.urlRoot()}/${this.id}`;
    },

    set: function (key, value, options) {
        // Normalize the key-value into an object
        let attrs;

        if (_.isObject(key) || key === null) {
            attrs = key;
            options = value;
        } else {
            attrs = {};
            attrs[key] = value;
        }

        // Go over all the set attrs and make your changes
        for (const attr in attrs) {
            if (attr === 'favoriteCatalogItems') {
                attrs[attr] = new FavoriteCatalogItems(attrs[attr], { userProfile: this });
                attrs[attr].on('add', () => this.fetch());
                attrs[attr].on('remove', () => this.fetch());
                attrs[attr].on('change', () => this.fetch());
            }
        }

        return Backbone.Model.prototype.set.call(this, attrs, options);
    },

    getCatalogItemFavorite: function (idOrCatalogItem) {
        if (isNaN(parseInt(idOrCatalogItem, 10))) {
            const catalogItem = idOrCatalogItem;
            const favorites = this.get('favoriteCatalogItems').filter((favorite) => (
                    favorite.get('catalogItem').id === catalogItem.id &&
                    favorite.get('catalogItem').get('dataSourceId') === catalogItem.get('dataSourceId')
                ));

            return (favorites.length === 0) ? null : favorites[0];
        }
        const id = idOrCatalogItem;
        const favorite = this.get('favoriteCatalogItems').get(id);
        return favorite;
    },

    addCatalogItemFavorite: function (catalogItem, callbacks) {
        const options = $.extend({
            wait: true,
            error: function () {},
            success: function () {}
        }, callbacks);

        this.get('favoriteCatalogItems').create({
            catalogItemId: catalogItem.id,
            dataSourceId: catalogItem.get('dataSourceId')
        }, options);
    },

    removeCatalogItemFavorite: function (idOrCatalogItem, callbacks) {
        const options = $.extend({
            wait: true,
            error: function () {},
            success: function () {}
        }, callbacks);

        const favorite = this.getCatalogItemFavorite(idOrCatalogItem);
        favorite.destroy(options);
    }
});



// WEBPACK FOOTER //
// ./model/UserProfile.js